<template>
  <div class="box">
    <img :src="pageInfo.topImg" alt="" class="topImg" v-if="pageInfo" />
    <div class="navTitle" v-if="pageInfo">{{ pageInfo.bannerTitle }}</div>
    <div
      class="navbar"
      v-if="pageInfo && pageInfo.secondModuleDtoList.length > 0"
    >
      <span
        :class="['navItem', index == chooseIndex ? 'active' : '']"
        v-for="(item, index) in pageInfo.secondModuleDtoList"
        :key="index"
        @click="changeIndex(index)"
        >{{ item.moduleTitle }}</span
      >
    </div>
    <div class="main">
      <!-- 商品列表 -->
      <div
        class="mainList"
        v-for="(item, index) in goodsList"
        :key="index"
        @click="gotoDetails(item.id)"
      >
        <div class="floor-imgBox">
          <img :src="item.thumb" alt="" class="mainList_img" />
          <img
            class="tag-img"
            :src="
              item.helpPoor == 0
                ? ''
                : item.helpPoor == 1
                ? '../../../static/image/helpPoor.png'
                : item.helpPoor == 2
                ? '../../../static/image/832.png'
                : item.helpPoor == 3
                ? '../../../static/image/cooperation.png'
                : item.helpPoor == 4
                ? '../../../static/image/characteristic.png'
                : item.helpPoor == 5
                ? '../../../static/image/support.png'
                : ''
            "
          />
        </div>
        <div class="mainList_body">
          <span style="display: flex"
            ><span class="mainList_text1">{{ item.title }}</span></span
          >
          <!-- <span class="mainList_text2">{{ item.supplierName }}</span> -->
          <div class="tagBox">
            <div
              class="tagList"
              v-for="(it, ind) in item.tagInfoPcList"
              :key="ind"
            >
              {{ it }}
            </div>
          </div>
          <div class="mainList_price">
            <div class="mainList_priceL">
              <span class="mainList_text3"
                ><span style="font-size: 12px">￥</span
                >{{ item.intervalPriceList[0].price.toFixed(2) }}</span
              ><span class="mainList_text4"
                >￥{{ item.productPrice.toFixed(2) }}</span
              >
            </div>
            <button class="mainList_btn" v-if="item.minBuyCount == 1">
              一{{ item.unit }}起订
            </button>
            <button class="minNumBox" v-else>
              起订量：{{ item.minBuyCount }}{{ item.unit }}
            </button>
          </div>
          <!-- <div class="mainList_shopCar" @click.stop="nothing()">
            <div class="mainList_shopCarL">
              <input
                type="text"
                class="mainList_shopCarNum"
                oninput="value=value.replace(/[^\d]/g,'')"
                v-model.number="item.num"
              />
              <div class="mainList_btnBox">
                <button
                  class="mainList_shopCarAdd"
                  style="transform: rotate(180deg)"
                  @click.stop="addNum(index)"
                >
                  <i class="iconfont">&#xe624;</i>
                </button>
                <button
                  class="mainList_shopCarAdd"
                  @click.stop="reduceNum(index)"
                >
                  <i class="iconfont">&#xe624;</i>
                </button>
              </div>
            </div>
            <button
              class="mainList_shopCarBtn"
              @click.stop="addShopCar(index, item)"
            >
              加入购物车
            </button>
          </div> -->
          <span class="mainList_tip" v-show="numList[index]"
            >采购数量须大于最小起订量</span
          >
        </div>
      </div>
      <el-empty
        style="margin: 0 auto"
        description="暂无数据"
        v-if="goodsList.length == 0"
      ></el-empty>
    </div>
    <!-- 分页 -->
    <div class="pagination" v-if="pageInfo">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="current"
        layout=" prev, pager, next,total, jumper"
        :total="total"
        :page-size="limit"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  data() {
    return {
      pageInfo: "",
      bannerId: this.$route.query.bannerId,
      peopleId: this.$cookies.isKey("peopleId")
        ? this.$cookies.get("peopleId")
        : "-1",
      chooseIndex: 0,
      numList: [false, false, false, false, false, false, false, false], //商品是否显示tip提示
      shopCarNum: 0, //商品选择数量
      current: 1, //当前页数
      total: 0, //总条数
      limit: 16, //每页显示几条
      goodsList: [], //商品列表
      shopCar: [], //购物车列表
    };
  },
  watch: {
    $route(to, from) {
      if (to.path == from.path && to.query != from.query) {
        this.bannerId = this.$route.query.bannerId; //分类id
        this.getInfo(); //获取商品列表
        this.shopCarNum = 0;
        this.shopCar.forEach((item) => {
          // item.info = JSON.parse(item.info);
          this.shopCarNum += item.info.num; //计算购物车商品总数
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "商品详情") {
      if (!from.meta.keepAlive) {
        from.meta.keepAlive = true;
      }
      next();
    } else {
      from.meta.keepAlive = false;
      to.meta.keepAlive = false;
      this.$destroy();
      next();
    }
  },
  mounted() {
    this.getShopCar();

    this.getInfo(); //获取基本信息
  },
  methods: {
    /**
     * 获取购物车
     */
    getShopCar() {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        { peopleId: this.$cookies.get("peopleId"), type: 0 },
        function (res) {
          if (res.flag) {
            that.shopCar = res.data;
            that.shopCarNum = 0;
            that.shopCar.forEach((item) => {
              item.info = JSON.parse(item.info);
              that.shopCarNum += item.info.num; //计算购物车商品总数
            });
          }
        },
        function (res) {}
      );
    },
    /**
     * 获取基本信息
     */
    getInfo() {
      var data = {
        bannerId: this.bannerId,
        peopleId: this.peopleId,
      };
      var that = this;
      doGet(httpConfig.Cooperation.getInfo, data, function (res) {
        if (res.flag) {
          that.pageInfo = res.data;
          if (that.pageInfo.secondModuleDtoList.length > 0) {
            that.getList(
              that.pageInfo.secondModuleDtoList[that.chooseIndex].id,
              1
            );
          }
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    /**
     * 获取商品列表
     */
    getList(id, val) {
      var data = {
        pn: val - 1,
        ps: this.limit,
        peopleId: this.peopleId,
        moduleId: id,
      };
      var that = this;

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      doGet(
        httpConfig.Cooperation.getListUrl,
        data,
        function (res) {
          that.goodsList = JSON.parse(JSON.stringify(res.data.rows));
          // that.goodsList.forEach((item) => {
          //   item["num"] = 0;
          //   that.shopCar.forEach((x) => {
          //     if (x.id === item.info.id) {
          //       item.num = x.info.num;
          //     }
          //   });
          // });
          that.total = res.data.total;
          that.current = val;
          loading.close();
        },
        function (res) {}
      );
    },
    changeIndex(index) {
      this.chooseIndex = index;
      this.getList(this.pageInfo.secondModuleDtoList[this.chooseIndex].id, 1);
    },
    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      this.numList = [false, false, false, false, false, false, false, false];
      this.getList(this.pageInfo.secondModuleDtoList[this.chooseIndex].id, val);
    },
    /**
     * 增加数量
     */
    addNum(index) {
      this.$set(this.goodsList[index], "num", this.goodsList[index].num + 1);
      this.$set(this.goodsList, index, this.goodsList[index]);
      if (this.goodsList[index].num >= this.goodsList[index].minBuyCount) {
        this.numList[index] = false;
      }
    },
    /**
     * 减少数量
     */
    reduceNum(index) {
      if (this.goodsList[index].num > 0) {
        this.$set(this.goodsList[index], "num", this.goodsList[index].num - 1);
        this.$set(this.goodsList, index, this.goodsList[index]);
      }
    },
    /**
     * 加入购物车
     */
    addShopCar(index, item) {
      if (this.$cookies.get("peopleId")) {
        if (this.goodsList[index].num < item.minBuyCount) {
          this.$set(this.numList, index, true);
        } else {
          this.$set(this.numList, index, false);
          var data = {
            thumb: item.thumb,
            title: item.title,
            supplierName: item.supplierName,
            wholesalePrice: item.wholesalePrice,
            productPrice: item.productPrice,
            num: item.num,
            id: item.id,
            isSelected: true,
            spec: item.spec,
            unit: item.unit,
          };
          if (this.$cookies.isKey("shopCar")) {
            var shopCar = JSON.parse(JSON.stringify(this.shopCar));
            for (var i = 0; i < shopCar.length; i++) {
              if (data.id == shopCar[i].id) {
                shopCar.splice(i, 1);
                i--;
              }
            }
            shopCar.push(data);
            this.$cookies.set("shopCar", JSON.stringify(shopCar));
          } else {
            this.$cookies.set("shopCar", JSON.stringify([data]));
          }
          this.$message({
            type: "success",
            message: "加入购物车成功",
          });
          this.shopCar = JSON.parse(this.$cookies.get("shopCar"))
            ? JSON.parse(this.$cookies.get("shopCar"))
            : [];
          this.shopCarNum = 0;
          this.shopCar.forEach((x) => {
            this.shopCarNum += x.num; //计算购物车商品总数
          });
          this.$store.commit("saveShopCarNum", this.shopCarNum);
        }
      } else {
        this.$message.warning("请先登录");
        this.$router.push("/login");
      }
    },
    /**
     * 返回顶部
     */
    gotoTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    /**
     * 商品详情
     */
    gotoDetails(id) {
      this.$router.push({ path: "/goodsInfo", query: { id: id } });
    },
    /**
     * 无效事件
     */
    nothing() {},
  },
};
</script>

<style scoped>
@import "../../assets/css/cooperation";
</style>



// WEBPACK FOOTER //
// src/components/page/cooperation.vue